module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('instamapsBreadcrumbs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasBreadcrumbs),
      expression: "hasBreadcrumbs"
    }],
    attrs: {
      "title": _vm.$t('title')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('form', {
    staticClass: "my-form-signin",
    attrs: {
      "id": "frm_login"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('section', [_c('h4', {
    staticClass: "form-signin-heading",
    attrs: {
      "lang": "ca"
    }
  }, [_vm._v(_vm._s(_vm.$t('title')))]), _vm._v(" "), _c('fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control my-border",
    attrs: {
      "id": "email",
      "name": "email",
      "data-vv-validate-on": "blur",
      "autofocus": "",
      "type": "text",
      "placeholder": _vm.$t('emailPlaceholder')
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "centered validationErrorMsg"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('emailValidation')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pass),
      expression: "form.pass"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:5'),
      expression: "'required|min:5'"
    }],
    staticClass: "form-control my-border",
    attrs: {
      "lang": "ca",
      "id": "signin_pass",
      "name": "pass",
      "type": "password",
      "data-vv-validate-on": "blur",
      "placeholder": _vm.$t('passwordPlaceholder')
    },
    domProps: {
      "value": (_vm.form.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "pass", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pass')),
      expression: "errors.has('pass')"
    }],
    staticClass: "centered validationErrorMsg"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('passValidation')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.confirmpass),
      expression: "form.confirmpass"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:5|confirmed:pass'),
      expression: "'required|min:5|confirmed:pass'"
    }],
    staticClass: "form-control my-border",
    attrs: {
      "lang": "ca",
      "id": "signin_confirm_pass",
      "name": "confirmpass",
      "type": "password",
      "data-vv-delay": "500",
      "placeholder": _vm.$t('cofirmPsswPlaceholder')
    },
    domProps: {
      "value": (_vm.form.confirmpass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "confirmpass", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('confirmpass')),
      expression: "errors.has('confirmpass')"
    }],
    staticClass: "centered validationErrorMsg"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('passEqualValidation')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn btn-lg bt-sessio btn-block",
    attrs: {
      "id": "perfil_button_pass",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.renovar()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('title')))])])])])])]), _vm._v(" "), _c('instamapsMessageModal', {
    attrs: {
      "delay": 10,
      "isError": _vm.modalIsError,
      "isLoaded": _vm.modalIsLoaded,
      "title": _vm.modalTitle,
      "message": _vm.modalMessage
    },
    on: {
      "loaded": _vm.loaded
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9067edec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/renovar/renovar.vue
// module id = 315
// module chunks = 0